// @ts-strict-ignore
import type { CatalogProductWithVariant } from "@emerson/data/queries/CatalogProductQuery/CatalogProduct.query";
import type { Variant } from "@shared/types/graphqlGenerated";

import { Description } from "./Description/Description";
import { DietaryConsiderations } from "./DietaryConsiderations/DietaryConsiderations";
import { Ingredients } from "./Ingredients/Ingredients";
import { SuggestedUse } from "./SuggestedUse/SuggestedUse";
import { Warnings } from "./Warnings/Warnings";

interface Props {
  product: Pick<
    CatalogProductWithVariant,
    | "id"
    | "shortDescription"
    | "emersonDescription"
    | "allergens"
    | "dosageInstructions"
    | "warnings"
    | "emersonWarnings"
    | "servingSize"
    | "servingUnit"
    | "otherIngredients"
    | "dosageAmount"
  >;
  variant: Pick<Variant, "id" | "servingsPerContainer">;
  isQuickView?: boolean;
}

const AdditionalProductDetails = ({ product, variant, isQuickView }: Props) => {
  const { id: variantId, servingsPerContainer } = variant || {};
  const productDescription = product.emersonDescription || product.shortDescription;

  return (
    <div>
      <Description shortDescription={productDescription} isDefaultExpanded={isQuickView} />
      <Ingredients
        servingSize={product.servingSize}
        servingUnit={product.servingUnit}
        servingsPerContainer={servingsPerContainer}
        otherIngredients={product.otherIngredients}
        variantId={variantId}
        isDefaultExpanded={isQuickView}
      />
      <DietaryConsiderations allergens={product.allergens} />
      <SuggestedUse dosageInstructions={product.dosageInstructions} />
      <Warnings warnings={product.emersonWarnings} />
    </div>
  );
};

export { AdditionalProductDetails };
